import { render, staticRenderFns } from "./PhieuSuaChuaVaChamCong.vue?vue&type=template&id=c28f7240"
import script from "./PhieuSuaChuaVaChamCong.vue?vue&type=script&lang=js"
export * from "./PhieuSuaChuaVaChamCong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports